/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import type { AddressDTO } from './address-dto'
import type { MServiceHistriesDTO } from './mservice-histries-dto'
/**
 *
 * @export
 * @interface AdminUserDTO
 */
export interface AdminUserDTO {
  /**
   *
   * @type {number}
   * @memberof AdminUserDTO
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof AdminUserDTO
   */
  login: string
  /**
   *
   * @type {string}
   * @memberof AdminUserDTO
   */
  firstName?: string
  /**
   *
   * @type {string}
   * @memberof AdminUserDTO
   */
  lastName?: string
  /**
   *
   * @type {string}
   * @memberof AdminUserDTO
   */
  email?: string
  /**
   *
   * @type {boolean}
   * @memberof AdminUserDTO
   */
  activated?: boolean
  /**
   *
   * @type {string}
   * @memberof AdminUserDTO
   */
  langKey?: string
  /**
   *
   * @type {Date}
   * @memberof AdminUserDTO
   */
  birthDate: Date
  /**
   *
   * @type {string}
   * @memberof AdminUserDTO
   */
  phoneNumber?: string
  /**
   *
   * @type {string}
   * @memberof AdminUserDTO
   */
  referralCode?: string
  /**
   *
   * @type {AddressDTO}
   * @memberof AdminUserDTO
   */
  address?: AddressDTO
  /**
   *
   * @type {number}
   * @memberof AdminUserDTO
   */
  balance?: number
  /**
   *
   * @type {number}
   * @memberof AdminUserDTO
   */
  remainingAmount?: number
  /**
   *
   * @type {string}
   * @memberof AdminUserDTO
   */
  interacPwd?: string
  /**
   *
   * @type {Array<MServiceHistriesDTO>}
   * @memberof AdminUserDTO
   */
  unAvailableService?: Array<MServiceHistriesDTO>
  /**
   *
   * @type {Array<string>}
   * @memberof AdminUserDTO
   */
  authorities?: Array<string>
  /**
   *
   * @type {string}
   * @memberof AdminUserDTO
   */
  gender?: AdminUserDTOGenderEnum
  /**
   *
   * @type {boolean}
   * @memberof AdminUserDTO
   */
  useConditionActivated?: boolean
  /**
   *
   * @type {boolean}
   * @memberof AdminUserDTO
   */
  identityCheck?: boolean
  /**
   * Current KYC verification status
   * @type {string}
   * @memberof AdminUserDTO
   */
  kycVerificationStatus?: string
  /**
   * When KYC was verified
   * @type {Date}
   * @memberof AdminUserDTO
   */
  kycVerifiedAt?: Date
  /**
   * KYC verification level
   * @type {string}
   * @memberof AdminUserDTO
   */
  kycVerificationLevel?: string
  /**
   * Is client KYC compliant
   * @type {boolean}
   * @memberof AdminUserDTO
   */
  isKycCompliant?: boolean
  /**
   * Latest verification session URL for mobile
   * @type {string}
   * @memberof AdminUserDTO
   */
  latestVerificationSessionUrl?: string
  /**
   * Latest verification ID
   * @type {number}
   * @memberof AdminUserDTO
   */
  latestVerificationId?: number
  /**
   * Latest verification status
   * @type {string}
   * @memberof AdminUserDTO
   */
  latestVerificationStatus?: string
}

/**
 * @export
 * @enum {string}
 */
export enum AdminUserDTOGenderEnum {
  MAN = 'MAN',
  WOMAN = 'WOMAN',
  OTHER = 'OTHER'
}
